import * as Sentry from '@sentry/vue';
import { useRoute } from 'vue-router';
import { AxiosError } from 'axios';
export var init = function (opts) {
    var _a, _b;
    var app = opts.app, dsn = opts.dsn;
    var enableOnLocal = (_a = opts.enableOnLocal) !== null && _a !== void 0 ? _a : false;
    var isLocal = window.location.href.includes('localhost') ||
        window.location.href.includes('127.0.0.1') ||
        window.location.href.includes('.test');
    var environment = ((_b = opts.environment) !== null && _b !== void 0 ? _b : window.location.href.includes('mumbleserver')) || isLocal ? 'development' : 'production';
    if (enableOnLocal ? true : !isLocal) {
        Sentry.init({
            app: app,
            dsn: dsn,
            environment: environment,
            ignoreErrors: [
                // Camera errors
                'RangeError',
                'AbortError',
                'No QR code found',
                // Vue Errors
                'Redirected when going from',
                'Avoided redundant navigation to current location',
                // General
                'Network Error',
                // Random plugins/extensions
                'top.GLOBALS',
                // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                "Can't find variable: ZiteReader",
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                // Facebook borked
                'fb_xd_fragment',
                // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this.
                // See http://stackoverflow.com/questions/4113268
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                'conduitPage',
            ],
            denyUrls: [
                // Facebook flakiness
                /graph\.facebook\.com/i,
                // Facebook blocked
                /connect\.facebook\.net\/en_US\/all\.js/i,
                // Woopra flakiness
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
                // Other plugins
                /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
                // ngrok
                /ngrok\.io/i,
            ],
        });
    }
};
export default function useSentry() {
    var route = useRoute();
    var log = function (error, opts) {
        var _a, _b;
        if (opts === void 0) { opts = {}; }
        var level = opts.level || 'error';
        var type = opts.type || 'other';
        var enableUserDataLog = (_a = opts.enableUserDataLog) !== null && _a !== void 0 ? _a : 'true';
        var extra = opts.extra;
        var status = undefined;
        var apiUrl = undefined;
        var ignoreStatus = opts.ignoreStatus || [];
        var user = opts.user;
        if (error instanceof AxiosError) {
            var response = error.response;
            type = 'api';
            status = response === null || response === void 0 ? void 0 : response.status;
            apiUrl = response === null || response === void 0 ? void 0 : response.config.url;
            if (status === 422) {
                var data = (response === null || response === void 0 ? void 0 : response.data) ? JSON.stringify(response.data) : undefined;
                extra
                    ? (extra.body = data)
                    : (extra = {
                        body: data,
                    });
            }
            if (ignoreStatus.length && status && ignoreStatus.includes(status))
                return false;
        }
        if (!enableUserDataLog && user) {
            user = {
                id: user.id,
                name: user.name,
                created_at: (_b = user.createdAt) !== null && _b !== void 0 ? _b : user.created_at,
            };
        }
        var context = {
            tags: {
                type: type,
                'api.status': status,
                'api.url': apiUrl,
                route: route ? route.name : undefined,
            },
            level: level,
            extra: extra,
            user: user,
        };
        // @ts-ignore
        Sentry.captureException(error, context);
    };
    return {
        log: log,
    };
}
